import { routes } from "config/routes";

export const logoutUser = (): void => {
  localStorage.clear();
  if (window.location.pathname.includes("/login")) {
    window.location.replace(routes.public.login);
  }
};
